import styled from '@emotion/styled';

export const Card = styled.div`
	background-color: ${({ formBackgroundColor }) => (formBackgroundColor ? `${formBackgroundColor}` : '#ffffff')};
	border-radius: 10px;
	box-shadow: var(--container-box-shadow);
	width: 100%;
`;

export const StatusContainer = styled.div`
	padding: 10px;
	text-align: center;
	border-radius: calc(0.35rem - 1px) calc(0.35rem - 1px) 0 0;
	background: ${({ headerBackgroundColor }) => (headerBackgroundColor ? `${headerBackgroundColor}` : '#2ecc71')};
	border-radius: 5px;
`;

export const DataContent = styled.div`
	padding: var(--padding-4);
	padding-left: var(--padding-5);
	div {
		padding: 5px 0;
	}
`;

export const GrandTotal = styled.div`
	text-align: right;
	body[dir='rtl'] & {
		text-align: left;
	}
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	gap: var(--padding-5);
	margin-top: 5rem;
`;
